var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomationInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 16 9)",
    stroke: "#222222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17,
    width: 4,
    height: 4,
    rx: 2,
    transform: "rotate(90 20 17)",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H16",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7V7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H12",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationInactive);
export default __webpack_public_path__ + "static/media/AutomationInactive.36ef65624c6d6a44172617c45c25b893.svg";
export { ForwardRef as ReactComponent };